// extracted by mini-css-extract-plugin
module.exports = {"initials":"SrSimpleContactCard--initials--vr3NQ","highlightYellowFadeIn":"SrSimpleContactCard--highlightYellowFadeIn--3pW3B"};